const typography = {
  fontFamily: ["Noto Sans"].join(","),
  fontSize: 16,
  // fontWeightLight: 300,
  fontWeightRegular: 400,
  // fontWeightMedium: 500,
  fontWeightBold: 700,
  // h1: {
  //   fontSize: "2rem",
  //   fontWeight: 600,
  //   lineHeight: 1.25,
  // },
  // h2: {
  //   fontSize: "1.75rem",
  //   fontWeight: 600,
  //   lineHeight: 1.25,
  // },
  h3: {
    fontSize: "1.75rem",
    fontWeight: 400,
    lineHeight: 2.384,
  },
  h4: {
    fontSize: "1.125rem",
    fontWeight: 400,
    lineHeight: 1.25,
  },
  // h5: {
  //   fontSize: "1.0625rem",
  //   fontWeight: 400,
  //   lineHeight: 1.25,
  // },
  h6: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.2,
  },
  body1: {
    fontSize: 13,
  },
  button: {
    textTransform: "none",
  },
};

export default typography;
